import { render, staticRenderFns } from "./UsuarioView.vue?vue&type=template&id=b635d046&"
import script from "./UsuarioView.vue?vue&type=script&lang=js&"
export * from "./UsuarioView.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports